import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";
import { handleFormChange } from "../../../../components/modals/EditableTable";
import InfoTip from "../../../../components/InfoTip";
import { ActivityMetricInfoIcon } from "../../../../components/ActivityDetailMetricIcons";
import WasteFlowColorSelect from "../WasteFlowColorSelect";
import WasteFlowFormPanel from "../WasteFlowFormPanel";
import {
  WASTE_FORM_INPUT_CLASS,
  WASTE_FORM_LABEL_CLASS,
  WASTE_FORM_REQUIRED,
} from "../wasteFlowFormUi";

const FieldHelpTip = ({ children }) => (
  <InfoTip widthMaxRem={20} nudgeY={0} icon={<ActivityMetricInfoIcon />}>
    <p className="m-0 text-[13px] leading-tight opacity-90">{children}</p>
  </InfoTip>
);

const WasteFlowGeneralTab = ({ formData, setFormData }) => {
  const { t } = useTranslation();

  const isAkanthasAccount = (Cookies.get("userEmail") || "").includes(
    "@akanthas.com",
  );
  const viewMode = Cookies.get("viewMode") || "client";

  return (
    <WasteFlowFormPanel title={t("General information")}>
      <div className="waste-flow-form-field">
        <label className={WASTE_FORM_LABEL_CLASS} htmlFor="waste-flow-label">
          {t("Name")} {WASTE_FORM_REQUIRED}
          <FieldHelpTip>{t("settingsWaste.nameHelp")}</FieldHelpTip>
        </label>
        <input
          id="waste-flow-label"
          type="text"
          name="label"
          className={WASTE_FORM_INPUT_CLASS}
          value={formData.label ?? ""}
          onChange={(e) => handleFormChange(e, formData, setFormData)}
          required
        />
      </div>

      <div className="waste-flow-form-field">
        <label className={WASTE_FORM_LABEL_CLASS} htmlFor="waste-flow-density">
          {t("Density")} {WASTE_FORM_REQUIRED}
          <FieldHelpTip>{t("settingsWaste.densityHelp")}</FieldHelpTip>
        </label>
        <div className="relative">
          <input
            id="waste-flow-density"
            type="number"
            name="density"
            className={`${WASTE_FORM_INPUT_CLASS} pr-[4.5rem]`}
            value={formData.density ?? ""}
            placeholder="230"
            min={0}
            onChange={(e) => handleFormChange(e, formData, setFormData)}
          />
          <span className="waste-flow-field-suffix" aria-hidden>
            kg/m³
          </span>
        </div>
      </div>

      <div className="waste-flow-form-field">
        <span className={WASTE_FORM_LABEL_CLASS} id="waste-flow-color-label">
          {t("Waste category color")} {WASTE_FORM_REQUIRED}
          <FieldHelpTip>{t("settingsWaste.colorHelp")}</FieldHelpTip>
        </span>
        <WasteFlowColorSelect
          value={formData.displayColor}
          onChange={(hex) =>
            setFormData((prev) => ({ ...prev, displayColor: hex }))
          }
          ariaLabel={t("Waste category color")}
          placeholder={t("settingsWaste.selectColor")}
        />
      </div>

      <div className="waste-flow-form-field">
        <span
          className={WASTE_FORM_LABEL_CLASS}
          id="waste-flow-valorization-label"
        >
          {t("settingsWaste.valorizationEligible")}
          <FieldHelpTip>
            {t("settingsWaste.valorizationEligibleHelp")}
          </FieldHelpTip>
        </span>
        <div className="waste-flow-form-toggle-row justify-end">
          <button
            type="button"
            role="switch"
            aria-checked={Boolean(formData.isValorizationEligible)}
            aria-labelledby="waste-flow-valorization-label"
            className={`waste-flow-toggle shrink-0${formData.isValorizationEligible ? " waste-flow-toggle--on" : ""}`}
            onClick={() =>
              setFormData((prev) => ({
                ...prev,
                isValorizationEligible: !prev.isValorizationEligible,
              }))
            }
          >
            <span className="waste-flow-toggle__thumb" />
          </button>
        </div>
      </div>

      {isAkanthasAccount && viewMode === "admin" && (
        <div className="waste-flow-form-field">
          <label
            className={WASTE_FORM_LABEL_CLASS}
            htmlFor="waste-flow-compaction"
          >
            {t("Packmat coefficient")}
          </label>
          <input
            id="waste-flow-compaction"
            type="number"
            name="compactionFactor"
            className={WASTE_FORM_INPUT_CLASS}
            value={formData.compactionFactor ?? 1}
            onChange={(e) => handleFormChange(e, formData, setFormData)}
          />
        </div>
      )}
    </WasteFlowFormPanel>
  );
};

export default WasteFlowGeneralTab;
